/* ═══════════════════════════════════════════════════════════════
   document-age-validator.js
   Validación global de compatibilidad Tipo de Documento ↔ Edad.
   Se aplica automáticamente a:
     - Registro (paso 2):  #TipoDocumento + #Documento + #FechaNacimiento
     - Edición/Creación (paso 3): #e-tipodoc + #e-documento + #e-fecha
   No requiere modificar custom.js, customer-edit.js ni los .liquid.
   AUTOR: Yohan Gomez.
   ═══════════════════════════════════════════════════════════════ */

(function () {

  /* ════════════════════════════════════
     1. REGLAS POR TIPO DE DOCUMENTO
     (portado de DocumentAgeValidatorService)
  ════════════════════════════════════ */
  var DOCUMENT_RULES = {
    CN: { ok: function (a) { return a <= 0.25; },              warn: function () { return false; } },
    RC: { ok: function (a) { return a <= 6.99; },               warn: function (a) { return a >= 7 && a <= 7.99; } },
    TI: { ok: function (a) { return a >= 7 && a <= 17.99; },    warn: function (a) { return a >= 18 && a <= 18.99; } },
    CC: { ok: function (a) { return a >= 18; },                 warn: function () { return false; } },
    CE: { ok: function () { return true; },                     warn: function () { return false; } },
    PA: { ok: function () { return true; },                     warn: function () { return false; } },
    CD: { ok: function () { return true; },                     warn: function () { return false; } },
    SC: { ok: function () { return true; },                     warn: function () { return false; } },
    PE: { ok: function () { return true; },                     warn: function () { return false; } },
    DE: { ok: function () { return true; },                     warn: function () { return false; } },
    PT: { ok: function () { return true; },                     warn: function () { return false; } },
    MS: { ok: function () { return false; },                    warn: function (a) { return a <= 7.99; } },
    AS: { ok: function (a) { return a >= 18; },                 warn: function () { return false; } }
    /* DNI, NIT, SYS, AMB: sin regla en la tabla oficial -> se consideran válidos por defecto */
  };

  /* ════════════════════════════════════
     2. MAPA ID -> ABREVIATURA
     (de ConsultDocumentType)
  ════════════════════════════════════ */
  var ID_TO_ABREV = {
    '1': 'CC', '2': 'CE', '3': 'CD', '4': 'PA', '5': 'SC',
    '6': 'PE', '7': 'RC', '8': 'TI', '9': 'CN', '10': 'AS',
    '11': 'MS', '12': 'DNI', '16': 'NIT', '17': 'SYS',
    '18': 'AMB', '20': 'PT'
  };

  /* ════════════════════════════════════
     3. HELPERS DE EDAD
  ════════════════════════════════════ */

  /**
   * Calcula la edad decimal a partir de una fecha 'YYYY-MM-DD'.
   * Replica DocumentAgeValidatorService.convertAgeToDecimal,
   * pero descompone directamente desde la fecha (no recibe años/meses/días sueltos).
   * @param {string} fechaStr
   * @returns {number|null}
   */
  function calcularEdadDecimal(fechaStr) {
    if (!fechaStr) return null;

    var fecha = new Date(fechaStr + 'T00:00:00');
    if (isNaN(fecha.getTime())) return null;

    var hoy = new Date();
    hoy.setHours(0, 0, 0, 0);

    // H8: desde R5 se acepta un recién nacido; nacido hoy es edad 0 y se valida
    // contra las reglas (antes devolvía null y cualquier documento pasaba).
    if (fecha > hoy) return null;
    if (fecha.getTime() === hoy.getTime()) return 0;

    var years  = hoy.getFullYear() - fecha.getFullYear();
    var months = hoy.getMonth()    - fecha.getMonth();
    var days   = hoy.getDate()     - fecha.getDate();

    if (days < 0) {
      months -= 1;
      // días del mes anterior al mes actual de "hoy"
      var prevMonth = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
      days += prevMonth.getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    var totalYearsFromMonths = (months || 0) / 12;
    var totalYearsFromDays   = (days   || 0) / 365;
    var convertAge = years + totalYearsFromMonths + totalYearsFromDays;

    return Math.floor(convertAge * 100) / 100;
  }

  /**
   * Evalúa la compatibilidad documento/edad.
   * @param {string} abreviatura
   * @param {number} edadDecimal
   * @returns {{isValid:boolean, isWarning:boolean}}
   */
  function evaluarDocumento(abreviatura, edadDecimal) {
    var rules = DOCUMENT_RULES[abreviatura];

    if (!rules || edadDecimal === null) {
      return { isValid: true, isWarning: false };
    }

    var isValid   = rules.ok(edadDecimal);
    var isWarning = !isValid ? rules.warn(edadDecimal) : false;

    return { isValid: isValid, isWarning: isWarning };
  }

  /* ════════════════════════════════════
     4. UI: FEEDBACK INDEPENDIENTE
     (no pisa el feedback de "documento existente")
  ════════════════════════════════════ */

  /**
   * Crea (si no existe) y devuelve el contenedor de feedback de edad/documento.
   * B25: el tipo de documento va en una columna de 110 px (.reg-field--shrink) y el mensaje
   * salía en 5 líneas. Si el campo está en una fila .reg-row, el mensaje va justo después
   * de la fila, a todo su ancho; si no, dentro del campo como antes.
   * @param {HTMLElement} tipoDocInput
   * @param {string} feedbackId
   */
  function getOrCreateFeedbackEl(tipoDocInput, feedbackId) {
    var el = document.getElementById(feedbackId);
    if (el) return el;

    el = document.createElement('div');
    el.id = feedbackId;
    el.className = 'doc-age-feedback';
    el.style.display = 'none';

    var fila = tipoDocInput.closest('.reg-row');
    if (fila && fila.parentNode) {
      fila.parentNode.insertBefore(el, fila.nextSibling);
    } else {
      var field = tipoDocInput.closest('.reg-field') || tipoDocInput.parentElement;
      field.appendChild(el);
    }

    return el;
  }

  /**
   * Aplica (o limpia) el estado visual de validación edad/documento.
   * @param {HTMLElement} tipoDocInput
   * @param {HTMLElement} docInput
   * @param {string} feedbackPrefix - prefijo único por formulario (ej: 'reg' | 'edit')
   * @param {{isValid:boolean, isWarning:boolean}|null} result
   */
  function aplicarFeedbackEdad(tipoDocInput, docInput, feedbackPrefix, result) {
    var feedbackId = 'doc-age-feedback-' + feedbackPrefix;
    var feedbackEl = getOrCreateFeedbackEl(tipoDocInput, feedbackId);
    var flagName   = 'doc-age-blocked-' + feedbackPrefix;

    /* Limpiar estado previo */
    tipoDocInput.classList.remove('doc-age-error', 'doc-age-warning');
    if (docInput) docInput.classList.remove('doc-age-error', 'doc-age-warning');
    feedbackEl.style.display = 'none';
    feedbackEl.textContent = '';
    delete window['_' + flagName.replace(/-/g, '_')];

    /* Flags globales legacy (compatibilidad con nombres pedidos) */
    if (feedbackPrefix === 'reg')  window._regDocAgeInvalid  = false;
    if (feedbackPrefix === 'edit') window._editDocAgeInvalid = false;

    if (!result) return;

    if (!result.isValid && !result.isWarning) {
      /* NO permitido — bloquea avance/guardado */
      tipoDocInput.classList.add('doc-age-error');
      if (docInput) docInput.classList.add('doc-age-error');
      feedbackEl.textContent = 'El tipo de documento seleccionado no corresponde a la edad del paciente.';
      feedbackEl.className = 'doc-age-feedback doc-age-feedback--error is-visible';
      feedbackEl.style.display = 'block';

      if (feedbackPrefix === 'reg')  window._regDocAgeInvalid  = true;
      if (feedbackPrefix === 'edit') window._editDocAgeInvalid = true;

    } else if (!result.isValid && result.isWarning) {
      /* Permitido con advertencia — NO bloquea */
      tipoDocInput.classList.add('doc-age-warning');
      if (docInput) docInput.classList.add('doc-age-warning');
      feedbackEl.textContent = 'El tipo de documento es inusual para la edad indicada. Verifica que sea correcto.';
      feedbackEl.className = 'doc-age-feedback doc-age-feedback--warning is-visible';
      feedbackEl.style.display = 'block';
    }
    /* Si isValid === true -> sin feedback, sin bloqueo */
  }

  /* ════════════════════════════════════
     5. VALIDADOR POR GRUPO DE CAMPOS
     (reutilizable para registro y edición/creación)
  ════════════════════════════════════ */

  /**
   * Liga la validación de edad/documento a un grupo de inputs.
   * @param {Object} cfg
   * @param {string} cfg.tipoDocId   - id del <select> tipo documento
   * @param {string} cfg.docId       - id del input documento (opcional, solo visual)
   * @param {string} cfg.fechaId     - id del input fecha de nacimiento
   * @param {string} cfg.prefix      - prefijo único para el feedback (ej: 'reg', 'edit')
   */
  function bindValidationGroup(cfg) {
    function run() {
      var tipoDocEl = document.getElementById(cfg.tipoDocId);
      var docEl     = document.getElementById(cfg.docId);
      var fechaEl   = document.getElementById(cfg.fechaId);

      if (!tipoDocEl || !fechaEl) return;

      var tipoDocValue = (tipoDocEl.value || '').trim();
      var fechaValue   = (fechaEl.value   || '').trim();

      if (!tipoDocValue || !fechaValue) {
        aplicarFeedbackEdad(tipoDocEl, docEl, cfg.prefix, null);
        return;
      }

      /* tipoDocValue puede ser el id numérico (1, 2, 3...) o ya la abreviatura (CC, TI...) */
      var abreviatura = ID_TO_ABREV[tipoDocValue] || tipoDocValue.toUpperCase();

      var edad = calcularEdadDecimal(fechaValue);
      var result = evaluarDocumento(abreviatura, edad);

      aplicarFeedbackEdad(tipoDocEl, docEl, cfg.prefix, result);
    }

    function attach() {
      var tipoDocEl = document.getElementById(cfg.tipoDocId);
      var fechaEl   = document.getElementById(cfg.fechaId);

      if (tipoDocEl && !tipoDocEl.dataset.ageValidatorBound) {
        tipoDocEl.dataset.ageValidatorBound = '1';
        tipoDocEl.addEventListener('change', run);
      }
      if (fechaEl && !fechaEl.dataset.ageValidatorBound) {
        fechaEl.dataset.ageValidatorBound = '1';
        fechaEl.addEventListener('change', run);
        fechaEl.addEventListener('blur', run);
      }

      /* Evaluar estado inicial si ambos campos ya tienen valor (ej: edición de paciente existente) */
      run();
    }

    /* Reintentar el bind hasta que los elementos existan
       (los selects de tipo de documento se llenan vía fetch async) */
    var attempts = 0;
    var maxAttempts = 40; /* ~10s a 250ms */
    var interval = setInterval(function () {
      attempts++;
      var tipoDocEl = document.getElementById(cfg.tipoDocId);
      var fechaEl   = document.getElementById(cfg.fechaId);

      if (tipoDocEl && fechaEl) {
        attach();
        /* Seguir reintentando un poco más por si el select cambia sus opciones después
           (re-bind es seguro porque usamos dataset flag) */
      }
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 250);

    /* Observador adicional: si el select de tipo de documento cambia su lista de opciones
       (ej: loadTipoDocumento en customer-edit.js lo repuebla), re-evaluar el valor actual */
    var tipoDocEl = document.getElementById(cfg.tipoDocId);
    if (tipoDocEl && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        run();
      });
      observer.observe(tipoDocEl, { childList: true });
    }
  }

  /* ════════════════════════════════════
     6. BLOQUEO DE SUBMIT/AVANCE
     Se ejecuta en fase de "capturing" (antes que los listeners
     originales de custom.js / customer-edit.js), para impedir
     continuar si hay un error de edad sin tocar esos archivos.
  ════════════════════════════════════ */

  function mostrarBloqueoEdad(msg) {
    if (typeof Swal !== 'undefined') {
      Swal.fire({
        icon: 'error',
        html: '<div style="text-align:center"><strong style="font-size:16px;color:#e31c79;">Documento no válido</strong>' +
              '<div style="margin-top:10px;font-size:14px;">' + msg + '</div></div>',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#e31c79',
        showCloseButton: true,
        allowOutsideClick: false
      });
    } else {
      alert(msg);
    }
  }

  function bindSubmitBlockers() {
    var MSG = 'El tipo de documento seleccionado no corresponde a la edad del paciente. Por favor corrige el tipo de documento o la fecha de nacimiento antes de continuar.';

    /* Paso 2 — Registro de cuenta (#crearCuenta) */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#crearCuenta')) return;
      if (window._regDocAgeInvalid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        mostrarBloqueoEdad(MSG);
      }
    }, true); /* capturing: se ejecuta antes que el handler de custom.js */

    /* Paso 3 — Guardar cambios / Crear paciente (#btn-save) */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#btn-save')) return;
      if (window._editDocAgeInvalid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        mostrarBloqueoEdad(MSG);
      }
    }, true);

    /* Paso 3 — Continuar a pago (#btn-continuar-pago) */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('#btn-continuar-pago')) return;
      if (window._editDocAgeInvalid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        mostrarBloqueoEdad(MSG);
      }
    }, true);

    /* Paso 3 — Avanzar vía accordion trigger (paso 3 -> 4) */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.cart-accordion__trigger');
      if (!trigger) return;
      var item = trigger.closest('.cart-accordion__item');
      if (parseInt(item && item.dataset.accordionIndex, 10) !== 3) return;
      if (window._editDocAgeInvalid) {
        e.preventDefault();
        e.stopImmediatePropagation();
        mostrarBloqueoEdad(MSG);
      }
    }, true);
  }

  /* ════════════════════════════════════
     7. INICIALIZACIÓN
  ════════════════════════════════════ */
  function init() {
    /* Paso 2 — Registro de cuenta */
    bindValidationGroup({
      tipoDocId: 'TipoDocumento',
      docId:     'Documento',
      fechaId:   'FechaNacimiento',
      prefix:    'reg'
    });

    /* Paso 3 — Edición / Creación de paciente */
    bindValidationGroup({
      tipoDocId: 'e-tipodoc',
      docId:     'e-documento',
      fechaId:   'e-fecha',
      prefix:    'edit'
    });

    bindSubmitBlockers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();